import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ONOTYFooter = _ref => {
  var {
    text,
    icons = [],
    children
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "max-w-7xl mx-auto py-2 my-8",
      style: {
        background: "linear-gradient(90deg, rgba(0,153,218,1) 0%, rgba(66,180,121,1) 100%)"
      }
    }), /*#__PURE__*/_jsxs("footer", {
      className: "mx-auto max-w-7xl grid grid-cols-2 gap-4 lg:gap-8 lg:px-8 py-2 mb-12",
      children: [/*#__PURE__*/_jsx("div", {
        className: "col-span-2 lg:col-span-1 flex items-end justify-center lg:justify-center",
        children: /*#__PURE__*/_jsx("p", {
          className: "text-2xl md:text-3xl text-center font-bold lg:pb-4",
          children: text
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "col-span-2 lg:col-span-1 grid grid-cols-2 divide-x-4 divide-grey w-100",
        children: icons.map((_ref2, i) => {
          var {
            filename,
            alt
          } = _ref2;
          return /*#__PURE__*/_jsx("a", {
            href: alt,
            className: "flex justify-center",
            children: /*#__PURE__*/_jsx("img", {
              className: "py-2 md:px-4 lg:px-8 min-h-12 max-h-20 my-auto object-scale-down object-center",
              src: filename,
              alt: alt
            })
          }, i);
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "col-span-2 flex items-center justify-center divide-x divide-grey pt-2 text-center text-base lg:text-xl",
        children: children
      })]
    })]
  });
};
//# sourceMappingURL=onoty_footer.js.map